module.exports = __webpack_public_path__ + "img/big3-9.e7f379b8.jpg";